/**
 * Keep admin payment status calculations aligned with the employee portal and
 * the server-side validation allowance for currency rounding.
 */
export const PAYMENT_AMOUNT_TOLERANCE = 0.1;

export function isPaymentAmountComplete(
  totalRequired: number,
  totalApproved: number
): boolean {
  return (
    totalRequired > 0 &&
    totalApproved >= totalRequired - PAYMENT_AMOUNT_TOLERANCE
  );
}
